import React from "react";
import './Footer.css';
import kineticLogo  from '../../assets/img/kinetic-menu-logo.png';

export default class Footer extends React.Component {

	render() {
		const TWITTER_URL="https://twitter.com/beyond_rarity"
		const LINKEDIN_URL="https://www.linkedin.com/company/kinetic-chain-llc/posts/?feedView=all"
		const MEDIUM_URL="https://medium.com/the-brr"

		return (
		<div className="footer-container">
			<img className="footer-logo" src={kineticLogo} alt=""/>

	    	<div className="social">
				<span className="item-body">&copy; 2022 Kinetic Chain</span>
				<div className="social-icon-wrapper">
					<a href={TWITTER_URL} target="_blank" className="icon-wrapper twitter-logo" rel="noreferrer" >
					</a>
					<a href={LINKEDIN_URL} target="_blank" className="icon-wrapper linkedin-logo" rel="noreferrer" >
					</a>
					<a href={MEDIUM_URL} target="_blank" className="icon-wrapper medium-logo" rel="noreferrer" >
					</a>
				</div>
				<div className="mobile-copyright item-body">
					&copy; 2022 Kinetic Chain
				</div>
	    	</div>
			<div className="footer-filler"></div>
		</div>
		);
	}

}
